import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Car,
  Repeat,
  Banknote,
  ShieldCheck,
  FileText,
  Wrench,
  Headphones,
  Tag,
  ArrowRight,
} from "lucide-react";

const services = [
  { icon: Car, title: "Buy Used Cars", desc: "Browse a meticulously curated inventory of premium pre-owned cars, each backed by a 150+ point inspection.", to: "/inventory" },
  { icon: Tag, title: "Sell Your Car", desc: "Get the best market price with same-day quote and instant payment options.", to: "/sell" },
  { icon: Repeat, title: "Car Exchange", desc: "Trade-in your existing car for an upgrade — transparent valuation, paperwork on us.", to: "/contact" },
  { icon: Banknote, title: "Finance Assistance", desc: "Tied up with leading banks & NBFCs for quick loan approvals, attractive interest rates.", to: "/contact" },
  { icon: ShieldCheck, title: "Insurance Assistance", desc: "Comprehensive insurance support — comparison, claims and renewals handled for you.", to: "/contact" },
  { icon: FileText, title: "RC Transfer Assistance", desc: "End-to-end RC transfer, NOC and documentation — you take the keys, we take care of the rest.", to: "/contact" },
  { icon: Wrench, title: "Vehicle Inspection", desc: "Comprehensive 150+ point inspection on engine, transmission, electrical, body and interiors.", to: "/contact" },
  { icon: Headphones, title: "Customer Support", desc: "Dedicated post-sale support — service tie-ups, warranty and roadside assistance.", to: "/contact" },
];

export default function ServicesPage() {
  useEffect(() => { document.title = "Services — Faisal Car Bazar"; }, []);

  return (
    <div data-testid="services-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="mb-12">
        <div className="eyebrow mb-4">Services</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F5DC] font-light">
          End-to-end care for <span className="text-[#DC143C] italic">every owner.</span>
        </h1>
        <div className="luxe-divider" />
        <p className="text-[#A0A0A0] max-w-2xl mt-4 leading-relaxed">
          From the first inquiry to long after the keys change hands — we orchestrate
          every detail of your pre-owned car ownership.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {services.map((s, i) => (
          <Link
            key={s.title}
            to={s.to}
            data-testid={`service-${i}`}
            className="premium-card p-7 group"
          >
            <div className="w-12 h-12 rounded-xl bg-[#DC143C]/10 border border-[#DC143C]/30 flex items-center justify-center mb-5">
              <s.icon className="text-[#DC143C]" size={22} />
            </div>
            <h3 className="font-display text-xl text-[#F5F5DC] mb-2">{s.title}</h3>
            <p className="text-sm text-[#A0A0A0] leading-relaxed mb-5">{s.desc}</p>
            <span className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] flex items-center gap-2 group-hover:gap-3 transition-all">
              Enquire <ArrowRight size={12} />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
